import ThemesProvider from './ThemeProvider';

export default ThemesProvider;
